module.exports = __webpack_public_path__ + "img/comparisonWhite.99faca3c.svg";